var map = {
	"./guest/casual/sara-forbes-bonetta.mdx": 79,
	"./guest/prestige/fairchilds.mdx": 80,
	"./meeple/butler.mdx": 81,
	"./meeple/housekeeper.mdx": 82,
	"./term/active-hand.mdx": 83,
	"./term/activity.mdx": 84,
	"./term/admirer-bonus.mdx": 85,
	"./term/builders-holiday.mdx": 86,
	"./tile/barn.mdx": 113,
	"./tile/brushing-room.mdx": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;